import { apiRequestActions } from '@ackee/redux-utils';
import { fetchWorkorderTypes } from './types';

export default apiRequestActions(fetchWorkorderTypes);
